import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=505b9a39&scoped=true"
import script from "./AiChatWidget.vue?vue&type=script&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=505b9a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b9a39",
  null
  
)

export default component.exports